import { render, staticRenderFns } from "./CmsEmbed.vue?vue&type=template&id=49e60ae8&"
import script from "./CmsEmbed.vue?vue&type=script&lang=js&"
export * from "./CmsEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports